<template>
    <div class="width100">

        <b-modal id="modalInfo" hide-footer
                 header-bg-variant="thtab"
                 header-text-variant="light">
            <template v-slot:modal-title>

            </template>
            <div class="d-block">
                <div v-if="errors2.length" class="alert alert-danger text-center" role="alert">
                    <p v-for="(error, key) in errors2" :key="key">{{ error }}</p>
                </div>
                <div v-if="msgs2.length" class="alert alert-success text-center" role="alert">
                    <p v-for="(msg, key) in msgs2" :key="key">{{ msg }}</p>
                </div>
            </div>
        </b-modal>

        <div class="row">
            <div class="col-10  offset-1">

                <div class="row">
                    <div class="col-4">
                        Titre
                    </div>
                    <div class="col-8" v-if="panneId==null">
                        <input type="text" v-model="titrePanne" class="form-control">
                    </div>
                    <div class="col-8" v-if="panneId!=null">
                        {{titrePanne}}
                    </div>
                </div>
                <br/>
                <div class="row">
                    <div class="col-4">
                        Défaut constaté
                    </div>
                    <div class="col-8" v-if="panneId==null">
                        <textarea v-model="defautPanne" class="form-control"></textarea>
                    </div>
                    <div class="col-8" v-if="panneId!=null">
                        {{defautPanne}}
                    </div>
                </div>
                <div class="row" v-if="panneId!=null">
                    <div class="col-md-12 col-lg-4 offset-lg-4">
                        <p v-html="photoData"></p>
                    </div>
                </div>
                <br/>
                <div class="row">
                    <div class="col-4">
                        Solution apportée
                    </div>
                    <div class="col-8">
                        <textarea v-model="solutionPanne" class="form-control"></textarea>
                    </div>
                </div>
                <br/>
                <div class="row">
                    <div class="col-4">
                        Durée (minute)
                    </div>
                    <div class="col-8">
                        <input type="number" v-model="duree" class="form-control">
                    </div>
                </div>
                <br/>
                <div v-if="machineType.charge==1" class="row">
                    <div class="col-4">
                        Niveau charge (minute)
                    </div>
                    <div class="col-8">
                        <div class="row">
                            <div class="col-9">
                                <input type="range" v-model="niveauCharge" class="form-control"
                                       min="0" max="100" value="90" step="10">
                            </div>
                            <div class="col-3">
                                {{niveauCharge}}%
                            </div>
                        </div>
                    </div>
                </div>
                <br/>
                <div v-if="machineType.horametre==1" class="row">
                    <div class="col-4">
                        Horametre
                    </div>
                    <div class="col-8">
                        <input type="number" v-model="horametre" class="form-control">
                    </div>
                </div>
                <br/>
                <!--<Picture @returnPicture="returnPicture"></Picture>-->
                <PictureNav @returnPictureNav="returnPictureNav"></PictureNav>
                <br />
                <div class="col-12 text-center">
                    <i v-if="dataUrl2 || image" class="fa-regular fa-trash-can fa-2x text-danger" @click="deletePicture()"></i>
                </div>
                <div class="row" v-if="dataUrl2">
                    <div class="col-12">
                        <p>Cette photo sera jointe à la panne :</p>
                        <b-img :src="dataUrl2" fluid-grow
                               alt="Responsive image"></b-img>
                    </div>
                </div>
                <p v-if='dataUrl2==null && image!=null' v-html="image"></p>
                <br/>
                <div class="row">
                    <div class="col-12 text-center">
                        <button class="btn btn-primary" block @click="savePanne()">
                            Valider
                        </button>
                        &nbsp;
                        <button class="btn btn-danger" block @click="returnAMaintenance()">Retour</button>
                        &nbsp;
                        <button v-if='idModif!=null' class="btn btn-danger" block @click="deletePanneOp()">Supprimer</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import PictureNav from './PictureNav';

    export default {
        name: "PanneReparationFormulaire",
        props: ['token', 'site', 'user', 'racine', 'machine', 'userId', 'panneId','machineType','idModif','panneIdModif','systemeClient'],
        data() {
            return {
                errors2: [], msgs2: [],
                panne: null,
                titrePanne: null, defautPanne: null, solutionPanne: null, duree: 0, niveauCharge: 0, horametre: 0,
                blob2: null, dataUrl2: null,lastHorametre:null,
                image:null
            };
        },
        methods:
            {
                savePanne() {
                    this.errors2 = [];
                    this.msgs2 = [];
                    if (this.titrePanne != null) {
                        const h = this.$createElement
                        var msgConfirm = []
                        msgConfirm.push(h('div', {class: ['foobar']}, [
                            h('p', {class: ['text-center']}, [
                                h('strong', 'Récapitulatif : '),
                            ]),
                            h('p', {class: ['text-center']}, [
                                "Titre : " + this.titrePanne
                            ]),
                        ]))

                        if (this.defautPanne != null) {
                            msgConfirm.push(h('div', {class: ['foobar']}, [
                                h('p', {class: ['text-center']}, [
                                    "Défaut : " + this.defautPanne
                                ]),
                            ]))
                            if (this.solutionPanne != null) {
                                msgConfirm.push(h('div', {class: ['foobar']}, [
                                    h('p', {class: ['text-center']}, [
                                        "Solution : " + this.solutionPanne
                                    ]),
                                ]))
                                if (this.duree > 0) {


                                    msgConfirm.push(h('div', {class: ['foobar']}, [
                                        h('p', {class: ['text-center']}, [
                                            "Durée : " + this.duree
                                        ]),
                                    ]))

                                    var valide = true
                                    if(this.machineType.charge==1)
                                    {//si chariot
                                        if(this.niveauCharge>0)
                                        {
                                            msgConfirm.push(h('div', { class: ['foobar'] }, [
                                                h('p', { class: ['text-center'] }, [
                                                    "Niveau de charge : "+this.niveauCharge
                                                ]),
                                            ]) )
                                        }
                                        else
                                        {
                                            this.errors2.push("Le niveau de charge n'est pas correct.")
                                            this.popup()
                                            valide = false
                                        }
                                    }
                                    if(this.machineType.horametre==1)
                                    {//si chariot
                                        console.log(this.horametre+'>='+this.lastHorametre)
                                        if(this.horametre>=this.lastHorametre)
                                        {
                                            msgConfirm.push(h('div', { class: ['foobar'] }, [
                                                h('p', { class: ['text-center'] }, [
                                                    "Horamètre : "+this.horametre
                                                ]),
                                            ]) )
                                        }
                                        else
                                        {
                                            this.errors2.push("L'horamètre est inférieur à la dernière fois.")
                                            this.popup()
                                            valide = false
                                        }
                                    }

                                    if (valide == true) {
                                        const messageVNode = msgConfirm
                                        this.$bvModal.msgBoxConfirm(messageVNode, {
                                            title: 'Confirmation',
                                            size: 'lg',
                                            buttonSize: 'lg',
                                            okVariant: 'danger',
                                            okTitle: 'Oui',
                                            cancelTitle: 'Non',
                                            footerClass: 'p-2',
                                            hideHeaderClose: false,
                                            centered: true,
                                            noFade: true
                                        })
                                            .then(value => {
                                                if (value == true) {


                                                    var myHeaders = new Headers();
                                                    myHeaders.append("Authorization", "Bearer "+this.token);

                                                    var formdata = new FormData();
                                                    formdata.append('date', this.today);
                                                    formdata.append('machine', this.machine['id']);
                                                    formdata.append('user', this.userId);
                                                    formdata.append('solution', this.solutionPanne);
                                                    formdata.append('titre', this.titrePanne);
                                                    formdata.append('panneId', this.panneId);
                                                    formdata.append('defaut', this.defautPanne);
                                                    formdata.append('duree', this.duree);
                                                    formdata.append('niveauCharge', this.niveauCharge);
                                                    formdata.append('horametre', this.horametre);
                                                    formdata.append('idModif', this.idModif);
                                                    formdata.append('photo', this.blob2);

                                                    var requestOptions = {
                                                        method: 'POST',
                                                        headers: myHeaders,
                                                        body: formdata,
                                                        redirect: 'follow'
                                                    };

                                                    fetch(this.racine + this.site + 'api/save_operation_panne',requestOptions)
                                                        .then(response => response.json())
                                                        .then(json => {
                                                            console.log(json);
                                                            if (json['msg'] != "") {
                                                                this.errors2.push(json['msg'])
                                                                this.popup()
                                                            }
                                                            else if (json['valide'] > 0) {
                                                                this.msgs2.push("La réparation de panne est enregistrée.")
                                                                this.popup()
                                                                setTimeout(() => {//on laisse le message quelques instants
                                                                    this.$emit('returnMaintenance')
                                                                }, 2000)

                                                            }
                                                            else {
                                                                this.errors2.push("Un problème inconnu s'est produit.")
                                                                this.popup()
                                                            }
                                                        })
                                                }
                                            })
                                    }


                                }
                                else {
                                    this.errors2.push("La durée n'est pas correcte.")
                                    this.popup()
                                }
                            }
                            else {
                                this.errors2.push("La solution n'est pas correcte.")
                                this.popup()
                            }
                        }
                        else {
                            this.errors2.push("Le défaut n'est pas correct.")
                            this.popup()
                        }
                    }
                    else {
                        this.errors2.push("Le titre n'est pas correct.")
                        this.popup()
                    }
                },
                getPanne() {
                    console.log(this.panneId)
                    if (this.panneId != null) {
                        fetch(this.racine + this.site + 'api/pannes/' + this.panneId, {
                            method: 'GET',
                            headers: {
                                'Content-Type': 'application/json',
                                'Authorization': 'Bearer ' + this.token
                            },
                        }).then(response => {
                            console.log(response)
                            response.json().then(json => {
                                if (json != undefined) {
                                    console.log(json)
                                    this.defautPanne = json['defaut']
                                    this.titrePanne = json['titre']
                                }
                            })
                        })

                    }
                },
                popup() {
                    this.$bvModal.show('modalInfo')
                    setTimeout(() => {//on laisse le message quelques instants
                        this.$bvModal.hide('modalInfo')
                        this.errors2 = []
                        this.msgs2 = []
                    }, 2000)
                },
                returnPicture(e) {
                    console.log("picture")
                    console.log(e)
                    this.blob2 = e[0]
                    this.dataUrl2 = e[1]
                },
                returnPictureNav(e) {
                    console.log("picture")
                    console.log(e)
                    this.blob2 = e[0]
                    this.dataUrl2 = e[1]
                },
                getLastHorametre()
                {
                    fetch(this.racine + this.site + 'api/get_last_operation/'+this.machine['id'], {
                        method: 'GET',
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': 'Bearer ' + this.token
                        },
                    }).then(response => {

                        console.log(response)
                        response.json().then(json => {
                            if (json != undefined) {
                                console.log(json)
                                this.lastHorametre = json['horametre']
                            }
                        })
                    })
                },
                ifModif() {
                    if (this.idModif != null) {
                        fetch(this.racine + this.site + 'api/pannes/'+this.panneIdModif, {
                            method: 'GET',
                            headers: {
                                'Content-Type': 'application/json',
                                'Authorization': 'Bearer ' + this.token
                            },
                        }).then(response => {

                            console.log(response)
                            response.json().then(json => {
                                if (json != undefined) {
                                    console.log(json)
                                    this.defautPanne = json['defaut']
                                    this.titrePanne = json['titre']
                                    this.solutionPanne = json['solution']
                                    this.machine = json['machine']
                                    this.panneId = this.panneIdModif
                                    fetch(this.racine + this.site + 'api/operations/'+this.idModif, {
                                        method: 'GET',
                                        headers: {
                                            'Content-Type': 'application/json',
                                            'Authorization': 'Bearer ' + this.token
                                        },
                                    }).then(response => {

                                        console.log(response)
                                        response.json().then(json => {
                                            if (json != undefined) {
                                                console.log(json)
                                                this.duree = json['duree']
                                                this.niveauCharge = json['niveauCharge']
                                                this.horametre = json['horametre']
                                                this.tache = json['tache']
                                                this.machine = json['machine']
                                                fetch(this.racine + this.site + 'api/get_photo_stat/'+this.idModif+'/panneReparation', {
                                                    method: 'GET',
                                                    headers: {
                                                        'Content-Type': 'application/json',
                                                        'Authorization': 'Bearer ' + this.token
                                                    },
                                                }).then(response => {
                                                    console.log(response)
                                                    response.json().then(json => {
                                                        if (json != undefined) {
                                                            console.log(json)
                                                            this.image = json['img']
                                                        }
                                                    })
                                                })
                                            }
                                        })
                                    })
                                }
                            })
                        })
                    }
                },
                deletePictureFinal()
                {
                    if (this.dataUrl2 != null) {
                        this.dataUrl2 = null
                        this.blob2 = null
                    }
                    else if (this.image != null && this.idModif != null) {
                        fetch(this.racine + this.site + 'api/delete_photo/'+this.idModif+'/panneReparation', {
                            method: 'GET',
                            headers: {
                                'Content-Type': 'application/json',
                                'Authorization': 'Bearer ' + this.token
                            },
                        }).then(response => {
                            console.log(response)
                            response.json().then(json => {
                                if (json != undefined) {
                                    console.log(json)
                                    this.image = json['img']
                                }
                            })
                        })
                    }
                },
                deletePicture()
                {
                    this.$bvModal.msgBoxConfirm("Voulez vous supprimer cette image ?", {
                        title: 'Confirmation',
                        size: 'lg',
                        buttonSize: 'lg',
                        okVariant: 'danger',
                        okTitle: 'Oui',
                        cancelTitle: 'Non',
                        footerClass: 'p-2',
                        hideHeaderClose: false,
                        centered: true,
                        noFade: true
                    })
                        .then(value => {
                            if (value == true) {
                                this.deletePictureFinal()
                            }
                        })
                },
                deletePanneOp()
                {
                    this.$bvModal.msgBoxConfirm("Voulez vous supprimer cette réparation ?", {
                        title: 'Confirmation',
                        size: 'lg',
                        buttonSize: 'lg',
                        okVariant: 'danger',
                        okTitle: 'Oui',
                        cancelTitle: 'Non',
                        footerClass: 'p-2',
                        hideHeaderClose: false,
                        centered: true,
                        noFade: true
                    })
                        .then(value => {
                            if (value == true) {

                                /*fetch(this.racine + this.site + 'api/operations/'+this.idModif, {
                                    method: 'DELETE',
                                    headers: {
                                        'Content-Type': 'application/json',
                                        'Authorization': 'Bearer ' + this.token
                                    },
                                }).then(response => {
                                    console.log(response)
                                    if (response.status == 204)
                                    {*/
                                        fetch(this.racine + this.site + 'api/del_operation_put_panne/'+this.idModif+'/'+this.panneId, {
                                            method: 'GET',
                                            headers: {
                                                'Content-Type': 'application/json',
                                                'Authorization': 'Bearer ' + this.token
                                            },
                                        }).then(response => {

                                            console.log(response)
                                            response.json().then(json => {
                                                if (json != undefined) {
                                                    console.log(json)
                                                    setTimeout(() => {//on laisse le message quelques instants
                                                        this.$emit('returnMaintenance')
                                                    }, 1000)
                                                }
                                            })
                                        })
                                  //  }
                                //})

                            }
                        })
                },
                returnAMaintenance()
                {
                    this.$emit('returnMaintenance')
                }
            },
        mounted() {
            this.getPanne()
            this.getLastHorametre()
        },
        created() {
            this.ifModif()

            var date = new Date()
            var month = date.getMonth() + 1
            var day = date.getDate()
            if (month < 10) {
                month = "0" + month
            }
            if (day < 10) {
                day = "0" + day
            }
            this.today = date.getFullYear() + '-' + month + '-' + day
        },
        components: {
            PictureNav,
        }
    }
</script>

<style scoped>

</style>